<template>
    <BaseModal :isShow="isShow" @close="emit('close')" size="md">
        <div class="flex flex-col w-full p-6 gap-4">
            <div class="">لطفا کد پیامک شده به شماره همراه خود را وارد نمایید.</div>
            <div class="flex justify-between mt-10 flex-col laptop:flex-row [&>*]:laptop:w-[45%] [&>*]:mb-4 [&>*]:laptop:mb-0">
                <div class="w-full laptop:w-[55%] border border-blue-700 border-opacity-60 rounded py-2 flex justify-around" @input="handleOtpInput" dir="ltr">
                    <template v-for="i in 6" :key="i">
                        <input
                            v-model="data[i - 1]"
                            ref="firstInputEl"
                            type="text"
                            maxlength="1"
                            class="border-b border-gray-400 w-5 h-5 text-center focus:border-blue-500 focus:border-b-2"
                            @paste="handlePaste($event, i)"
                        />
                    </template>
                </div>
                <div class="w-full laptop:w-2/5">
                    <BaseButton  @click="confirmOTP" lead size="full" text="ثبت کد" />
                </div>
            </div>
            <div v-if="otpError" class="text-red-500 text-xs mt-1 ms-1 font-bold">
                <p v-text="otpError" class="font-12" />
            </div>
            <div class=" text-xs flex justify-center" :class="time === 0 ? 'font-bold cursor-pointer' : 'opacity-60'" @click="resendCode">
                ارسال مجدد کد <div dir="ltr" class="w-10">{{ timeComputed }}</div>
            </div>
        </div>
    </BaseModal>
</template>
  
<script setup>
const props = defineProps({
    isShow: Boolean,
    otpError: String
})

const data = ref([])
const firstInputEl = ref(null);

const emit = defineEmits(['close', 'OTPConfirmed', 'retry'])

const time = ref(120)

setInterval(()=>{
    if(time.value > 0)
    time.value = time.value -1
},1000)

watch(()=>props.isShow, () => {
    data.value = []
    time.value = 120
} )

const timeComputed = computed(()=>{
    return `${Math.floor(time.value/60)} : ${(time.value%60).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  })}`
})

const handleOtpInput = (e) => {
  if (e.data && e.target.nextElementSibling) {
    e.target.nextElementSibling.focus();
  } else if (e.data == null && e.target.previousElementSibling) {
    e.target.previousElementSibling.focus();
  }
};

const handlePaste = (e, index) => {
  const pasteData = e.clipboardData.getData('text');
  let nextEl = firstInputEl.value[0].nextElementSibling;
  for (let i = 1; i < pasteData.length; i++) {
    if (nextEl) {
      data.value[index + i - 1] = pasteData[i];
      nextEl = nextEl.nextElementSibling;
    }
  }
};

const resendCode = () => {
    if(time.value === 0){
        emit('retry')
        time.value = 120
    }else{
        console.log(`${time.value} seconds remaining`)
    }
}

const confirmOTP = () => {
    let VerCode = data.value.toString().replaceAll(',','')
    emit('OTPConfirmed', VerCode.slice(0, 6))
}
</script>